<script setup lang="ts">
/*  eslint-disable import/no-dynamic-require, global-require */
import { ref, onMounted } from 'vue';

const props = defineProps<{
	label?: string;
	flag?: string;
	hideCurrency?: boolean;
}>();

const flagUrl = ref(' ');

onMounted(() => {
	try {
		flagUrl.value = require(`./flags/${props.flag?.toLowerCase()}.webp`);
	} catch {
		flagUrl.value = ' ';
	}
});
</script>
<template>
	<div class="flex items-center gap-2" data-test="country-flag">
		<img
			:src="flagUrl"
			alt="Country flag"
			width="24"
			height="16"
			data-test="flag-img"
			class="border-1-neutral rounded-1"
		/>
		<span v-show="!hideCurrency" class="text-weight-medium" data-test="flag-label">{{
			label?.toUpperCase() || '-'
		}}</span>
	</div>
</template>
